export default "__VITE_ASSET__h10KquHz__"